import { Grid, makeStyles, Menu, MenuItem, Typography } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { BaseLayout, Header, Loader, NoSessionData } from "../components";
import CardItem from "../components/CardItem";
import EPostersFavouriteGrid from "../components/EPostersFavouriteGrid";
import { getFavourites } from "../ducks/actions";
import * as types from "../ducks/types";
import { DeleteEposterFavouritesDialog } from "../features/eposters";
import { useCongress } from "../hooks";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(3)
    }
  },
  filter: {
    marginLeft: theme.spacing(1),
    flexGrow: 0.2
  }
}));

const FavouritesPage = () => {
  const classes = useStyles();
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const { congress } = useCongress();

  if (congress.enableFeatureLearn) {
    history.push(`/learn/favourites`);
  }

  useEffect(() => {
    dispatch(getFavourites());
  }, [dispatch]);

  const {
    data: { data: favourites },
    loading
  } = useQuery({ type: types.GET_FAVOURITES, defaultData: { data: [] } });

  const sessions = favourites
    .filter(({ favouritable }) => favouritable?.type === "session")
    .map(({ favouritable: { recordings, ...s }, id }) => ({
      ...s,
      videoUrl: !isEmpty(recordings) && recordings[0].videoUrl,
      favouritableId: id
    }));

  const ePosters = favourites
    .filter(({ favouritable }) => favouritable?.type === "eposter")
    .map(({ favouritable: { document, ...e }, id }) => ({
      ...e,
      previewUrl: !isEmpty(document) && document.previewUrl,
      favouritableId: id
    }));
  const [anchorEl, setAnchorEl] = useState(null);
  const [eposterId, setEposterId] = useState(null);
  const [deleteEposterDialogOpen, setDeleteEposterDialogOpen] = useState(false);

  const onMenuOpen = (e, { favouritableId }) => {
    setAnchorEl(e.currentTarget);
    setEposterId(favouritableId);
  };
  const onMenuClose = () => {
    setAnchorEl(null);
  };
  const onDeleteEposterDialogOpen = () => {
    setDeleteEposterDialogOpen(true);
    setAnchorEl(null);
  };
  const onDeleteEposterDialogClose = () => {
    setDeleteEposterDialogOpen(false);
  };

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon="star"
        title={intl.formatMessage({
          id: "Pages.FavouritesPage.Favourites",
          defaultMessage: "Favourites"
        })}
      />
      <Loader loading={loading}>
        <Typography variant="h6" gutterBottom>
          <strong>
            {intl.formatMessage({
              id: "Pages.FavouritesPage.Sessions",
              defaultMessage: "Sessions"
            })}
          </strong>
        </Typography>
        <NoSessionData data={sessions}>
          <Grid container spacing={3}>
            {sessions.map(({ id, title, description, videoUrl, favouritableId, exhibitors }) => (
              <Grid key={id} item xs={12} sm={3}>
                <CardItem
                  title={title}
                  description={description}
                  videoUrl={videoUrl}
                  onClick={() => {
                    history.push(`/sessions/${id}`);
                  }}
                  isEditable
                  onEdit={e => {
                    onMenuOpen(e, { favouritableId });
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  sponsored={exhibitors && exhibitors?.length > 0}
                />
              </Grid>
            ))}
          </Grid>
        </NoSessionData>
        <Typography variant="h6" gutterBottom>
          <strong>
            {intl.formatMessage({
              id: "Pages.FavouritesPage.EPosters",
              defaultMessage: "e-Posters"
            })}
          </strong>
        </Typography>
        <EPostersFavouriteGrid ePosters={ePosters} isEditable onEdit={onMenuOpen} />

        <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={onMenuClose}>
          <MenuItem onClick={onDeleteEposterDialogOpen}>
            {intl.formatMessage({
              id: "Pages.FavouritesPage.Remove",
              defaultMessage: "Remove"
            })}
          </MenuItem>
        </Menu>
        {deleteEposterDialogOpen && (
          <DeleteEposterFavouritesDialog id={eposterId} onClose={onDeleteEposterDialogClose} />
        )}
      </Loader>
    </BaseLayout>
  );
};

export default FavouritesPage;
